/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { AuthProps } from "aws-amplify-react/props";
import SubMenu from "../SubMenu";
import styles from "./MyAccount.module.css";
import { Profile } from "./Profile";
import Company from "./Company";
import { Payment } from "./Payment";
import { Contacts } from "./Contacts";
import { Switch, Route } from "react-router-dom";
import { Manage } from "./Manage";
import { Developer } from "./Developer";
import { useTranslation } from "react-i18next";

const MyAccount: React.FC<AuthProps> = ({ authData }) => {
  const { t } = useTranslation("common");

  const { role = "" } = authData.signInUserSession.idToken.payload;
  return (
    <React.Fragment>
      <title>{t("my_account_title")}</title>
      <SubMenu sessionInfo={authData.signInUserSession.idToken.payload} />
      <div className={styles.myAccountContainer}>
        <Switch>
          <Route
            path="/Company"
            exact
            render={() => <Company authData={authData} />}
          />
          {role !== "USER" && (
            <Route
              path="/Billing"
              exact
              render={() => <Payment authData={authData} />}
            />
          )}
          {role !== "USER" && (
            <Route
              path="/Contacts"
              exact
              render={() => <Contacts authData={authData} />}
            />
          )}
          {role !== "USER" && (
            <Route
              path="/Developer"
              exact
              render={() => (
                <Developer
                  sessionInfo={authData.signInUserSession.idToken.payload}
                />
              )}
            />
          )}
          {role.startsWith("SUPPORT") && (
            <Route
              path={["/Manage", "/Manage/:page"]}
              exact
              render={() => (
                <Manage
                  sessionInfo={authData.signInUserSession.idToken.payload}
                />
              )}
            />
          )}
          <Route
            path={["/", "/MyAccount"]}
            exact
            render={() => <Profile authData={authData} />}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
};

export default MyAccount;
